import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import {
  getApprovalByType,
  days,
  hasSign,
  renderDate,
  renderTime,
  renderDateTime,
  getDayIndexSignDate,
  renderSign,
  renderCustomInfo01,
  renderCustomInfo02
} from './utils/PtwCommonUtils.tsx';

interface IProps {
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  const approvalList = props.itemData?.approvalMVOList;
  const issueSiteVerification = getApprovalByType(approvalList, 'ISSUE', 1);
  const issuePerforming = getApprovalByType(approvalList, 'ISSUE', 2);
  const issueReviewing = getApprovalByType(approvalList, 'ISSUE', 3);
  const issueApproval = getApprovalByType(approvalList, 'ISSUE', 4);
  const issueCoordinator = getApprovalByType(approvalList, 'ISSUE', 5);
  const dailySubcontractorSv = getApprovalByType(approvalList, 'DAILY', 1);
  const dailySeaSv = getApprovalByType(approvalList, 'DAILY', 2);
  const dailyExtendedWork = getApprovalByType(approvalList, 'DAILY', 3);
  const closingCoordinator = getApprovalByType(approvalList, 'CLOSURE', 1);

  const todayDayIndex =
    getDayIndexSignDate(dailySubcontractorSv?.signCreateDate) !== -1
      ? getDayIndexSignDate(dailySubcontractorSv?.signCreateDate)
      : getDayIndexSignDate(dailySeaSv?.signCreateDate);

  useEffect(() => {
    //console.log(approvalList, 121212);
  }, [issueSiteVerification]);
  return (
    <div>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col />
          <col width="11%" />
          <col width="11%" />
          <col width="11%" />
          <col width="11%" />
          <col width="11%" />
          <col width="11%" />
          <col width="11%" />
          <col width="11%" />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={4} className={'saf-border-bottom-none'}>
              ISSUE
              <br />
              (OPEN)
            </th>
            <th colSpan={2}>JOB PERFORMER 01&02</th>
            <th colSpan={2}>PERFORMING AUTHORITY</th>
            <th colSpan={2}>AREA AUTHORITY</th>
            <th colSpan={2}>ISSUING AUTHORITY (IA)</th>
          </tr>
          <tr>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
          </tr>
          <tr>
            <td className="saf-td-center">&nbsp;</td>
            <td className="saf-td-center">&nbsp;</td>
            <td className="saf-td-center" rowSpan={2}>
              {issuePerforming?.signType ? renderCustomInfo01(issuePerforming) : ''}
            </td>
            <td className="saf-td-center saf-sign-field" rowSpan={2}>
              {renderSign(issuePerforming)}
            </td>
            <td className="saf-td-center" rowSpan={2}>
              {issueReviewing?.signType ? renderCustomInfo01(issueReviewing) : ''}
            </td>
            <td className="saf-td-center saf-sign-field" rowSpan={2}>
              {renderSign(issueReviewing)}
            </td>
            <td className="saf-td-center" rowSpan={2}>
              {issueApproval?.signType ? renderCustomInfo01(issueApproval) : ''}
            </td>
            <td className="saf-td-center saf-sign-field" rowSpan={2}>
              {renderSign(issueApproval)}
            </td>
          </tr>
          <tr>
            <td className="saf-td-center">&nbsp;</td>
            <td className="saf-td-center">&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col />
          <col width="5%" />
          <col width="10%" />
          <col width="10%" />
          <col width="10%" />
          <col width="10%" />
          <col width="10%" />
          <col width="10%" />
          <col width="5%" />
          <col width="10%" />
          <col width="10%" />
          <col width="10%" />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={2}>Days</th>
            <th rowSpan={2}>Terms</th>
            <th colSpan={2}>Signed Date</th>
            <th colSpan={2}>Job Performer</th>
            <th colSpan={2}>Area Authority</th>
            <th colSpan={4}>Extended Hour Sign (AA)</th>
          </tr>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th colSpan={2}>Extended Hour</th>
            <th>NAME</th>
            <th>SIGN</th>
          </tr>
          {days.map((day) => {
            const visible = day.index === todayDayIndex;
            return (
              <Fragment key={day.label}>
                <tr>
                  <th className={'saf-bg-white'} rowSpan={2}>
                    {day.label}
                  </th>
                  <th>From</th>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible && hasSign(dailySubcontractorSv)
                      ? renderDate(dailySubcontractorSv)
                      : ''}
                    <br />
                    {visible && hasSign(dailySeaSv) ? renderDate(dailySeaSv) : ''}
                  </td>
                  <td className={'saf-td-center'}>
                    {visible && hasSign(dailySubcontractorSv)
                      ? renderTime(dailySubcontractorSv)
                      : ''}
                  </td>

                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible && hasSign(dailySubcontractorSv)
                      ? renderCustomInfo02(dailySubcontractorSv)
                      : ''}
                  </td>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible ? renderSign(dailySubcontractorSv) : ''}
                  </td>

                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible && hasSign(dailySeaSv) ? renderCustomInfo02(dailySeaSv) : ''}
                  </td>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible ? renderSign(dailySeaSv) : ''}
                  </td>
                  <th>From</th>
                  <td>&nbsp;</td>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible && hasSign(dailyExtendedWork)
                      ? renderCustomInfo02(dailyExtendedWork)
                      : ''}
                  </td>
                  <td className={'saf-td-center'} rowSpan={2}>
                    {visible ? renderSign(dailyExtendedWork) : ''}
                  </td>
                </tr>

                <tr>
                  <th>To</th>
                  <td className={'saf-td-center'}>
                    {visible && hasSign(dailySeaSv) ? renderTime(dailySeaSv) : ''}
                  </td>
                  <th>To</th>
                  <td>&nbsp;</td>
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </table>
      <table className={'preview-table'}>
        <colgroup>
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th
              rowSpan={4}
              className={'saf-border-bottom-none'}
              style={{ backgroundColor: '#FFFF00' }}
            >
              SITE
              <br />
              Verification
            </th>
            <th rowSpan={2}>DATE & TIME</th>
            <th colSpan={2} className={'preview-right-border'}>
              SE&A Area Lead HSSE
            </th>
            <th rowSpan={2} style={{ backgroundColor: '#E2EFD9' }}>
              SE&A PTW Coordinator(OPEN)
            </th>
            <th rowSpan={2} style={{ backgroundColor: '#FBE4D5' }}>
              SE&A PTW Coordinator(CLOSE)
            </th>
          </tr>
          <tr>
            <th>NAME</th>
            <th className={'preview-right-border'}>SIGN</th>
          </tr>
          <tr>
            <td className={'saf-td-center'}>
              {issueSiteVerification?.signType ? renderDateTime(issueSiteVerification) : ''}
            </td>
            <td className={'saf-td-center'}>
              {issueSiteVerification?.signType ? issueSiteVerification?.userNm : ''}
            </td>
            <td className={'preview-right-border saf-td-center saf-sign-field'}>
              &nbsp;{renderSign(issueSiteVerification)}&nbsp;
            </td>
            <td rowSpan={2} className={'saf-td-center saf-border-bottom-none'}>
              {renderSign(issueCoordinator)}
              <br />
              <br />
              <span>
                {issueCoordinator?.signType ? renderDateTime(issueCoordinator) : ''}
                &nbsp;
                {issueCoordinator?.signType ? issueCoordinator?.userNm : ''}
              </span>
            </td>
            <td rowSpan={2} className={'saf-td-center saf-border-bottom-none'}>
              {renderSign(closingCoordinator)}
              <br />
              <br />
              <span>
                {closingCoordinator?.signType ? renderDateTime(closingCoordinator) : ''}
                &nbsp;
                {closingCoordinator?.signType ? closingCoordinator?.userNm : ''}
              </span>
            </td>
          </tr>
          <tr>
            <td colSpan={3} className={'saf-td-left'} style={{ paddingLeft: '3px' }}>
              <span style={{ fontSize: '.8em' }}>
                Comment : {issueSiteVerification?.comment ? issueSiteVerification?.comment : '-'}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
